import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Select
import Select from "react-select";

// Alert Dialog
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

// Yup
import * as yup from 'yup';

// Formik
import { Form, Formik } from 'formik';

// Navigation
import { useNavigate, Navigate } from 'react-router-dom';

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

// Components
import FunctionalTextInput from '../../components/Inputs/FunctionalInput';
import FunctionalButton from '../../components/Buttons/FunctionalButton';
import LoginForm from '../../components/LoginForm';

@inject('AuthStore', 'StoreStore')
@observer

class CreateDocument extends React.Component<any> {
    state: any = {
        step: 1,
        smsStatus: false,
        smsStepContinue: false,
        smsCode: Helpers.generateOtpCode(),
        code: Helpers.randomUniq(),
        values: {},
        resetForms: {}
    };

    constructor(props: any) {
        super(props);
    }

    render() {
        const customerInitialValues: any = {
            customer_name_surname: "",
            customer_address: "",
            customer_phone: "",
            customer_email: "",
        };

        const smsInitialValues: any = {
            sms_code: ""
        };

        const systemInitialValues: any = {
            vehicle_brand: "",
            vehicle_type: "",
            vehicle_model: "",
            vehicle_kilometer: "",
            vehicle_plate: "",
            vehicle_chassis_number: "",
            system_type: "",
            regulator_number: "",
            montage_date: "",
            guarantee_start_date: "",
            guarantee_finish_date: "",
            type: "",
            store: localStorage.getItem('storeId')
        };

        const storeId: any = localStorage.getItem('storeId');
        const sertificateTypes = this.props.StoreStore.stores[storeId].guarantee_sertificates.data.map((sertificate: any) => {
            return {
                value: sertificate.attributes.type,
                label: Helpers.translation(sertificate.attributes.type + '_guarantee')
            }
        });
        console.log(this.state.smsCode);
        return (
            storeId !== null ?
                <CommerceLayout
                    title={Helpers.translation('create')}
                    visibleCategories={false}
                >
                    {/* {this.state.smsCode} */}

                    {
                        this.props.AuthStore.userData.isLogin ?
                            <section id="shop">
                                <div className="container mx-auto p-4">
                                    <div className="flex flex-col">
                                        <div className="w-full">
                                            <Formik
                                                initialValues={customerInitialValues}
                                                onSubmit={(values: any, { resetForm }) => {
                                                    confirmAlert({
                                                        title: Helpers.translation('warning'),
                                                        message: Helpers.translation('are-you-sure-with-information'),
                                                        buttons: [
                                                            {
                                                                label: Helpers.translation('yes'),
                                                                onClick: async () => {
                                                                    const response = await Helpers.createDocumentStepOne({
                                                                        ...values,
                                                                        code: this.state.code,
                                                                        sms_code: this.state.smsCode
                                                                    });

                                                                    if (response.status) {
                                                                        const resetForms = this.state.resetForms;
                                                                        resetForms["customer_informations"] = resetForm;

                                                                        this.setState({
                                                                            values: {
                                                                                ...this.state.values,
                                                                                ...values,
                                                                                code: this.state.code,
                                                                            },
                                                                            smsStatus: true,
                                                                            resetForms
                                                                        })
                                                                    }
                                                                }
                                                            },
                                                            {
                                                                label: Helpers.translation('no'),
                                                            }
                                                        ]
                                                    });
                                                }}
                                                validationSchema={yup.object().shape({
                                                    customer_name_surname: yup
                                                        .string()
                                                        .required(Helpers.translation('cannot_be_left_blank')),
                                                    customer_address: yup
                                                        .string()
                                                        .required(Helpers.translation('cannot_be_left_blank')),
                                                    customer_phone: yup
                                                        .string()
                                                        .required(Helpers.translation('cannot_be_left_blank'))
                                                })}
                                            >
                                                {(props: any) => {
                                                    return (
                                                        <Form className="w-full">
                                                            <div className="text-lg font-bold mb-2">
                                                                {Helpers.translation('customer_informations')}
                                                            </div>

                                                            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                                                                <FunctionalTextInput
                                                                    name="customer_name_surname"
                                                                    placeholder={Helpers.translation('name_surname')}
                                                                    label={Helpers.translation('name_surname')}
                                                                    errors={props.errors.customer_name_surname}
                                                                    value={props.values.customer_name_surname}
                                                                    disabled={this.state.smsStepContinue}
                                                                />

                                                                <FunctionalTextInput
                                                                    name="customer_address"
                                                                    placeholder={Helpers.translation('address')}
                                                                    label={Helpers.translation('address')}
                                                                    errors={props.errors.customer_address}
                                                                    value={props.values.customer_address}
                                                                    disabled={this.state.smsStepContinue}
                                                                />

                                                                <FunctionalTextInput
                                                                    name="customer_phone"
                                                                    placeholder={Helpers.translation('phone')}
                                                                    label={Helpers.translation('phone')}
                                                                    errors={props.errors.customer_phone}
                                                                    value={props.values.customer_phone}
                                                                    disabled={this.state.smsStepContinue}
                                                                />

                                                                <FunctionalTextInput
                                                                    name="customer_email"
                                                                    placeholder={Helpers.translation('email')}
                                                                    label={Helpers.translation('email')}
                                                                    errors={props.errors.customer_email}
                                                                    value={props.values.customer_email}
                                                                    disabled={this.state.smsStepContinue}
                                                                />
                                                            </div>

                                                            {
                                                                this.state.step === 1 &&
                                                                <FunctionalButton
                                                                    text={Helpers.translation('send_sms')}
                                                                    fullWidth={false}
                                                                    customClasses="mt-4"
                                                                    rounded
                                                                />
                                                            }
                                                        </Form>
                                                    )
                                                }}
                                            </Formik>

                                            {
                                                this.state.smsStatus &&
                                                <Formik
                                                    initialValues={smsInitialValues}
                                                    onSubmit={(values: any, { resetForm }) => {
                                                        const resetForms = this.state.resetForms;
                                                        resetForms["sms"] = resetForm;

                                                        if (this.state.smsCode === values.sms_code) {
                                                            this.setState({
                                                                smsStatus: false,
                                                                smsStepContinue: true,
                                                                step: 2,
                                                                resetForms
                                                            })
                                                        } else {
                                                            confirmAlert({
                                                                title: Helpers.translation('error'),
                                                                message: Helpers.translation("sms-code-fault"),
                                                                buttons: [
                                                                    {
                                                                        label: Helpers.translation('i-got-it'),
                                                                    }
                                                                ]
                                                            });
                                                        }
                                                    }}
                                                    validationSchema={yup.object().shape({
                                                        sms_code: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank'))
                                                    })}
                                                >
                                                    {(props: any) => {
                                                        return (
                                                            <Form className="w-full mt-4">
                                                                <div className="text-lg font-bold mb-2">
                                                                    {Helpers.translation('sms_approve')}
                                                                </div>

                                                                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                                                                    <FunctionalTextInput
                                                                        name="sms_code"
                                                                        placeholder={Helpers.translation('sms_code')}
                                                                        label={Helpers.translation('sms_code')}
                                                                        errors={props.errors.sms_code}
                                                                    />
                                                                </div>

                                                                <FunctionalButton
                                                                    text={Helpers.translation('approve')}
                                                                    fullWidth={false}
                                                                    customClasses="mt-4"
                                                                    rounded
                                                                />
                                                            </Form>
                                                        )
                                                    }}
                                                </Formik>
                                            }

                                            {
                                                this.state.step === 2 &&
                                                <Formik
                                                    initialValues={systemInitialValues}
                                                    onSubmit={(values: any, { resetForm }) => {
                                                        confirmAlert({
                                                            title: Helpers.translation('warning'),
                                                            message: Helpers.translation('are-you-sure-with-information'),
                                                            buttons: [
                                                                {
                                                                    label: Helpers.translation('yes'),
                                                                    onClick: async () => {
                                                                        resetForm(systemInitialValues);
                                                                        this.state.resetForms['customer_informations'](systemInitialValues);
                                                                        this.state.resetForms['sms'](systemInitialValues);

                                                                        Helpers.createDocument({
                                                                            ...this.state.values,
                                                                            ...values
                                                                        })
                                                                    }
                                                                },
                                                                {
                                                                    label: Helpers.translation('no'),
                                                                }
                                                            ]
                                                        });
                                                    }}
                                                    validationSchema={yup.object().shape({
                                                        vehicle_brand: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                        vehicle_type: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                        vehicle_model: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                        vehicle_kilometer: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                        vehicle_plate: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                        vehicle_chassis_number: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                        system_type: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                        regulator_number: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                        montage_date: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                        guarantee_start_date: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                        guarantee_finish_date: yup
                                                            .string()
                                                            .required(Helpers.translation('cannot_be_left_blank')),
                                                        type: yup.object().shape({
                                                            value: yup
                                                                .string()
                                                                .required(Helpers.translation('cannot_be_left_blank')),
                                                        })
                                                    })}
                                                >
                                                    {(props: any) => {
                                                        return (
                                                            <Form className="w-full mt-4">
                                                                <div className="text-lg font-bold mb-2">
                                                                    {Helpers.translation('vehicle_information')}
                                                                </div>

                                                                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                                                                    <div>
                                                                        <label className="block text-grey-darker text-sm font-bold mb-2">{Helpers.translation('type')}</label>

                                                                        <Select
                                                                            options={sertificateTypes}
                                                                            value={props.values.type}
                                                                            onChange={(value) => props.setFieldValue("type", value)}
                                                                        />
                                                                    </div>

                                                                    <FunctionalTextInput
                                                                        name="vehicle_brand"
                                                                        placeholder={Helpers.translation('brand')}
                                                                        label={Helpers.translation('brand')}
                                                                        errors={props.errors.vehicle_brand}
                                                                        value={props.values.vehicle_brand}
                                                                    />

                                                                    <FunctionalTextInput
                                                                        name="vehicle_type"
                                                                        placeholder={Helpers.translation('type')}
                                                                        label={Helpers.translation('type')}
                                                                        errors={props.errors.vehicle_type}
                                                                        value={props.values.vehicle_type}
                                                                    />

                                                                    <FunctionalTextInput
                                                                        name="vehicle_model"
                                                                        placeholder={Helpers.translation('model')}
                                                                        label={Helpers.translation('model')}
                                                                        errors={props.errors.vehicle_model}
                                                                        value={props.values.vehicle_model}
                                                                    />

                                                                    <FunctionalTextInput
                                                                        name="vehicle_kilometer"
                                                                        placeholder={Helpers.translation('kilometer')}
                                                                        label={Helpers.translation('kilometer')}
                                                                        errors={props.errors.vehicle_kilometer}
                                                                        value={props.values.vehicle_kilometer}
                                                                    />

                                                                    <FunctionalTextInput
                                                                        name="vehicle_plate"
                                                                        placeholder={Helpers.translation('plate')}
                                                                        label={Helpers.translation('plate')}
                                                                        errors={props.errors.vehicle_plate}
                                                                        value={props.values.vehicle_plate}
                                                                    />

                                                                    <FunctionalTextInput
                                                                        name="vehicle_chassis_number"
                                                                        placeholder={Helpers.translation('chassis_number')}
                                                                        label={Helpers.translation('chassis_number')}
                                                                        errors={props.errors.vehicle_chassis_number}
                                                                        value={props.values.vehicle_chassis_number}
                                                                    />
                                                                </div>

                                                                <div className="text-lg font-bold mb-2 mt-4">
                                                                    {Helpers.translation('system_information')}
                                                                </div>

                                                                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                                                                    <FunctionalTextInput
                                                                        name="system_type"
                                                                        placeholder={Helpers.translation('system_type')}
                                                                        label={Helpers.translation('system_type')}
                                                                        errors={props.errors.system_type}
                                                                        value={props.values.system_type}
                                                                    />

                                                                    <FunctionalTextInput
                                                                        name="regulator_number"
                                                                        placeholder={Helpers.translation('regulator_number')}
                                                                        label={Helpers.translation('regulator_number')}
                                                                        errors={props.errors.regulator_number}
                                                                        value={props.values.regulator_number}
                                                                    />

                                                                    <div>
                                                                        <label className="block text-grey-darker text-sm font-bold mb-2">{Helpers.translation('images')}</label>

                                                                        <input
                                                                            className="border border-gray-300 rounded w-full py-2 px-3 text-grey-darker h-10 text-sm"
                                                                            id="file"
                                                                            name="images"
                                                                            type="file"
                                                                            multiple
                                                                            onChange={(event: any) => {
                                                                                props.setFieldValue("images", event.currentTarget.files);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">
                                                                    <div>
                                                                        <label className="block text-grey-darker text-sm font-bold mb-2">{Helpers.translation('montage_date')}</label>

                                                                        <input
                                                                            type="date"
                                                                            className="border border-gray-300 rounded h-10 w-full px-2"
                                                                            value={props.values.montage_date}
                                                                            onChange={(value: any) => props.setFieldValue('montage_date', value.target.value)}
                                                                        />

                                                                        {
                                                                            props.errors.montage_date !== undefined &&
                                                                            <div className="text-red-500 text-sm mt-1">{props.errors.montage_date}</div>
                                                                        }
                                                                    </div>

                                                                    <div>
                                                                        <label className="block text-grey-darker text-sm font-bold mb-2">{Helpers.translation('guarantee_start_date')}</label>

                                                                        <input
                                                                            type="date"
                                                                            className="border border-gray-300 rounded h-10 w-full px-2"
                                                                            value={props.values.guarantee_start_date}
                                                                            onChange={(value: any) => props.setFieldValue('guarantee_start_date', value.target.value)}
                                                                        />

                                                                        {
                                                                            props.errors.guarantee_start_date !== undefined &&
                                                                            <div className="text-red-500 text-sm mt-1">{props.errors.guarantee_start_date}</div>
                                                                        }
                                                                    </div>

                                                                    <div>
                                                                        <label className="block text-grey-darker text-sm font-bold mb-2">{Helpers.translation('guarantee_finish_date')}</label>

                                                                        <input
                                                                            type="date"
                                                                            className="border border-gray-300 rounded h-10 w-full px-2"
                                                                            value={props.values.guarantee_finish_date}
                                                                            onChange={(value: any) => props.setFieldValue('guarantee_finish_date', value.target.value)}
                                                                        />

                                                                        {
                                                                            props.errors.guarantee_finish_date !== undefined &&
                                                                            <div className="text-red-500 text-sm mt-1">{props.errors.guarantee_finish_date}</div>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <FunctionalButton
                                                                    text={Helpers.translation('save')}
                                                                    fullWidth={false}
                                                                    customClasses="mt-4"
                                                                    rounded
                                                                />
                                                            </Form>
                                                        )
                                                    }}
                                                </Formik>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </section>
                            :
                            <LoginForm
                                message={Helpers.translation('you_need_login_for_view_this_page')}
                            />
                    }
                </CommerceLayout>
                :
                <Navigate to="/" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    return <CreateDocument {...props} navigate={navigate} />
}

export default WithNavigate